import { usePosthogClient } from './(internal)/client'

/**
 * Variante de un feature flag de PostHog (reactivo).
 * Punto de entrada de la app: hidratación en cliente y ausencia de POSTHOG_KEY.
 */
export function useFeatureFlagVariantKey(flag: string) {
  const variant = ref<string | boolean | undefined>(undefined)
  let unsubscribe: (() => void) | undefined

  function syncVariant(posthog = usePosthogClient()) {
    if (!posthog?.getFeatureFlag) return
    try {
      variant.value = posthog.getFeatureFlag(flag)
    } catch {
      variant.value = undefined
    }
  }

  // Solo en onMounted: leer la flag en setup del cliente provoca mismatch de
  // hidratación (servidor = undefined/control, cliente = variante de PostHog).
  onMounted(() => {
    const posthog = usePosthogClient()
    syncVariant(posthog)
    if (!posthog?.onFeatureFlags) return
    const unsub = posthog.onFeatureFlags(() => {
      syncVariant(posthog)
    })
    if (typeof unsub === 'function') {
      unsubscribe = unsub
    }
  })

  onUnmounted(() => {
    if (typeof unsubscribe === 'function') {
      unsubscribe()
    }
  })

  return variant
}
